import Index from './index.vue'
// import Create from './components/Create.vue'
import List from '@/modules/MasjidImage/Screen/components/List.vue'


export default [
  {
    path: 'screen',
    name: 'screen',
    component: Index,
    title: 'screen',
    redirect: { name: 'screen-list' },
    children: [
      {
        path: 'list',
        name: 'screen-list',
        component: List,
      },
    ],
  },
]
